import { matchPath } from 'react-router';
import { createSelector } from 'reselect';

import { PATH } from 'constants/RoutesConstants';
import { getCurrentLocation } from 'selectors/router';
import { getProps } from 'utils/selectors';

/** @return {import("../reducers").GatesReducer} */
const getState = state => state.gates;

const getDataState = createSelector(getState, state => state.data);

export const getDataIds = createSelector(getDataState, state => state.ids);

export const getDataEntities = createSelector(getDataState, state => state.entities);

export const getGateById = createSelector(
  getDataEntities,
  getProps,
  (entities, gateId) => entities[gateId]
);

export const getGateByIds = createSelector(getDataEntities, getProps, (entities, gateIds) =>
  gateIds.reduce((acc, gateId) => {
    const exists = Boolean(entities[gateId]);
    if (exists) {
      return [...acc, entities[gateId]];
    }
    return acc;
  }, []));

export const getUIState = createSelector(getState, state => state.ui);

export const getSelectedGateId = createSelector(getCurrentLocation, location => {
  const match = matchPath(PATH.GATE_MANAGEMENT_DETAILS.path, location);
  return match?.params?.gateId;
});

export const getGateSelectById = createSelector(
  getUIState,
  getProps,
  (ui, selectId) => ui.selects[selectId]
);
